var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2073 6.90245L35 4.23079V3.646H25.3254L18.4304 20.8077L10.586 3.646H0.441875V4.23079L3.70417 8.15808C4.02208 8.44829 4.18833 8.87266 4.14604 9.29995V24.7335C4.24667 25.2891 4.06583 25.8608 3.675 26.2647L0 30.7185V31.296H10.4198V30.7112L6.74479 26.2647C6.34667 25.8593 6.15854 25.2979 6.23875 24.7335V11.3839L15.3854 31.3033H16.4485L24.3133 11.3839V27.252C24.3133 27.6706 24.3133 27.7566 24.0392 28.0308L21.21 30.7681V31.3543H34.9358V30.7695L32.2088 28.0993C31.9696 27.9185 31.8456 27.6152 31.8967 27.3206V7.6812C31.8456 7.38516 31.9681 7.08183 32.2073 6.90245V6.90245Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMedium);
export default __webpack_public_path__ + "static/media/logo_medium.932a875c6c1ac449fa6a58cc228ec4a7.svg";
export { ForwardRef as ReactComponent };